/* Product-page mobile launcher. App configuration and conversation behavior are preserved. */
(function () {
  'use strict';
  var attempts = 0;
  function compactLauncher() {
    var host = document.querySelector('shopify-chat');
    var runtime = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = runtime && runtime.shadowRoot;
    var button = root && root.querySelector('[part="activator"]');
    if (!button) {
      if (attempts++ < 40) setTimeout(compactLauncher, 500);
      return;
    }
    if (root.getElementById('femily-copy-chat-style')) return;
    var label = button.querySelector('.activator__label');
    if (label && label.textContent.trim()) button.setAttribute('aria-label', label.textContent.trim());
    var style = document.createElement('style');
    style.id = 'femily-copy-chat-style';
    style.textContent = '@media(max-width:767px){' +
      '.activator-nudge{position:fixed!important;inset:auto 14px 196px auto!important;width:48px!important;height:48px!important;transform:none!important}' +
      '.activator{position:static!important;width:48px!important;min-width:48px!important;height:48px!important;padding:12px!important;gap:0!important;border-radius:50%!important}' +
      '.activator__label{display:none!important}' +
      '.activator__icon{flex:none!important;width:24px!important;height:24px!important}' +
      '}';
    root.appendChild(style);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', compactLauncher, { once: true });
  else compactLauncher();
}());
